import React, { useEffect, useRef } from 'react'
import OneOrManyFlights from './one-or-many-flights'
import ContactForm4Column from './contact-form/4-column'
import Cta from './cta'
import form from '../../form'

const submitAttrs = {
  type: 'submit',
}

const SingleStep = () => {
  const wrapper = useRef(null)
  useEffect(() => {
    form(wrapper.current)
  }, [])

  return (
    <div ref={wrapper} className='ticket-landing'>
      <form
        action='email-notification/handle-booking-form.php'
        className='form-animation'
        data-focus-first-invalid
        data-animated-submission
        data-redirect='thanks.html'
        data-recaptcha-protected
      >
        <div data-form-messages>
          <div className='form-animation__message form-animation__success'>
            Success
          </div>
          <div className='form-animation__message invalid form-animation__error'>
            Error
          </div>
          <div className='form-animation__message invalid form-animation__error-network'>
            Network error
          </div>
        </div>

        <OneOrManyFlights spacerClass='mb-8' />

        <ContactForm4Column />

        <div className='flex-container align-center ticket-landing__button'>
          <div className='ticket-landing__submit'>
            <Cta tag='button' attributes={submitAttrs}>
              Request charter quotes
            </Cta>
          </div>
        </div>
      </form>
    </div>
  )
}

export default SingleStep
